import React from 'react';
// import Spin from 'antd/lib/spin';
// import { Spin } from 'antd';
import RnkimInfo from '../../blocks/PageInfo/RnkimInfo';

import style from './RnkimContent.module.scss';
import api from '../../../helpers/api';
import getReferrerFrom from '../../../helpers/lib/getReferrerFrom';

const RnkimContent = () => {
  // const [loading, setLoading] = React.useState<boolean>(true);
  //
  // const [iframe, setIframe] = React.useState<any>();

  const onReport = async () => {
    await api.sendReport(api.API_RNKIM_REPORT_TYPE, {
      ...getReferrerFrom(),
    });
  };

  // React.useEffect(() => {
  //   (async () => {
  //     const formData = new FormData();
  //     formData.append('workspaceId', '1561ffef-733d-4245-9304-967845c84e64');
  //     formData.append('reportId', 'acb25998-9815-430c-a294-b2b2ae71d246');
  //     formData.append('role', '');
  //     formData.append('role', '');
  //     await fetch('https://biapi.tektorg.ru/Home/Report', {
  //       headers: {
  //         'Access-Control-Allow-Origin': '*',
  //       },
  //       method: 'POST',
  //       body: formData,
  //     })
  //       .then((response) => response.text())
  //       .then((data) => {
  //         setLoading(false);
  //         setIframe(data);
  //       })
  //       .catch((e) => {
  //         console.log(e);
  //       });
  //   })();
  // }, []);

  return (
    <>
      <div className={style.container}>
        <RnkimInfo />
      </div>
      <div className={style.frame}>
        <iframe
          onLoad={onReport}
          width="100%"
          height="100%"
          src="https://pix.tektorg.ru/shared/view/875d26f7-53e2-4b1f-ac80-bd17bf1825a3"
          title="Rnkim content"
        />
        {/* {!loading ? (
          <iframe onLoad={onReport} width="100%" height="100%" srcDoc={iframe} title="Visiology" />
        ) : (
          <div className={style.spin}>
            <Spin />
          </div>
        )} */}
      </div>
    </>
  );
};

export default RnkimContent;
